<div class="paneContentNoPadding">
	@let loadedChecklists = checklists();
	@if (isLoading()) {
		<sim-component-loading-container
			[isLoading]="isLoading()"
			[loadingIcon]="'fad fa-clipboard-list-check'"
			[loadingMessage]="T.CHECKLIST_PANEL_LOADING | translate"
		/>
	} @else if (!loadedChecklists?.length) {
		<sim-panel-content-warning-container
			[warningTitle]="T.CHECKLIST_PANEL_CONTENT_WARNING_TITLE | translate"
			[warningDescription]="T.CHECKLIST_PANEL_CONTENT_WARNING_DESCRIPTION | translate"
		/>
	} @else {
		<div class="checklistHolder h-100">
			<mat-tab-group [mat-stretch-tabs]="false" color="accent" class="fullHeight h-100" [(selectedIndex)]="selectedTabIndex">
				@for (checklist of loadedChecklists; track checklist.id) {
					<mat-tab [label]="checklist?.name">
						<div class="checklistItemHolder">
							@if (selectedTabIndex === $index) {
								<sim-checklist-panel
									[disabled]="recording()?.state === ScenarioRecordingState.Prepared"
									[assessable]="checklist"
									[mode]="userToLoadChecklistsFor() ? AssessablePanelMode.View : AssessablePanelMode.Answer"
									[isInArchive]="!!userToLoadChecklistsFor()"
									(onJumpToItem)="jumpToChecklistItem.emit($event)"
								/>
							}
						</div>
					</mat-tab>
				}
			</mat-tab-group>
		</div>
	}
</div>
